<template>
  <BaseModal
    no-padding
    no-exit
    card-width="450px"
  >
    <template #toolbar>
      <div class="relative w-full">
        <div class="px-5 pt-3 pb-5 w-full flex items-center justify-center">
          <div class="block-warning-icon danger-block">
            <WarningIcon class="text-white w-full h-full" />
          </div>
        </div>
        <button
          class="absolute top-0 right-0 p-1.5"
          @click="handleClose"
        >
          <TagRemoveIcon stroke="#303546" />
        </button>
      </div>
    </template>
    <template #default>
      <div class="px-11 py-3 text-center">
        <BaseText
          type="label"
          size="sm"
          class="text-text-muted"
        >
          Please turn off the AdBlocker.
        </BaseText>
        <BaseText
          size="sm"
          class="text-text-normal"
        >
          It looks like you are using AdBlock software. That's ok. Who doesn't? We don't run ads, but disabling it can help improve performance and prevent bugs.
        </BaseText>
      </div>
      <!-- Footer -->
      <div class="p-5">
        <button
          class="w-full danger-block text-white rounded-md px-3 py-1.5 hover:bg-secondary-red-100 transition-colors"
          @click="handleAgreement"
        >
          <BaseText
            type="label"
            size="sm"
          >
            Refresh
          </BaseText>
        </button>
        <!-- <BaseText
          class="text-text-disabled text-center mt-2"
          size="xs"
        >
          The browser will refresh
        </BaseText> -->
      </div>
    </template>
  </BaseModal>
</template>
<script>
import WarningIcon from '../globals/Icons/WarningIcon.vue'
import TagRemoveIcon from '../globals/Icons/TagRemoveIcon.vue'
export default {
  name: 'AdBlockWarningModal',
  components: {
    WarningIcon,
    TagRemoveIcon
  },
  methods: {
    updateAcknowledgment () {
      localStorage.setItem('adblock_acknowledged', 'true')
    },
    handleAgreement () {
      this.updateAcknowledgment()
      window.location.reload()
    },
    handleClose () {
      this.updateAcknowledgment()
      this.$emit('close')
    }
  }
}
</script>
<style scoped>
.danger-block{
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: var(--Secondary-Red-100, #F4003A);
  box-shadow: 0px 1px 2px 0px rgba(124, 0, 31, 0.50), 0px 0px 0px 1px #C80031;
}

.block-warning-icon{
  width: 44px;
  height: 44px;
  border-radius: 10px;
  padding: 10px;
}
</style>
